import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Trans } from 'react-i18next';
import { Theme } from '@app/theme';
import { SubmitButton, SubmitButtonProps } from '@app/core';

import { SubmitType } from '../fieldConfigurations';

const useStyles = createUseStyles((theme: Theme) => ({
  button: {
    textAlign: 'center',
    marginTop: theme.marginBase * 7,
  },
}));

interface Props {
  submitType?: SubmitType;
  disabled?: boolean;
}

export const CustomFormFieldSubmitButton = ({
  submitType,
  ...rest
}: Props & SubmitButtonProps) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  switch (submitType) {
    case SubmitType.DONE:
      return (
        <div className={classes.button}>
          <SubmitButton
            color="green"
            trackingName="Screener Finished"
            fullMobileWidth
            {...rest}
          >
            <Trans i18nKey={'screeningForm.end'} />
          </SubmitButton>
        </div>
      );
    default:
    case SubmitType.CONTINUE:
      return (
        <div className={classes.button}>
          <SubmitButton
            withNextArrow
            trackingName="Screener Next"
            fullMobileWidth
            {...rest}
          >
            <Trans i18nKey={'screeningForm.continue'} />
          </SubmitButton>
        </div>
      );
  }
};
